import {
  TIMETABLE_ITEMS_FOR_VIEW,
  timetable_items_for_viewSubscription,
  timetable_items_for_viewSubscriptionVariables,
} from '@app-types/graphql-types';
import { useSubscription } from '@apollo/client';
import { TimetableCalendarItem } from '@app-types/timetable';
import moment from 'moment';
import { timetableTourSteps, ViewTimetable } from '@modules/timetable';
import { useMst } from '@models/Root';
import { AppTours } from '@modules/app';

export const StaffViewTimetable = () => {
  const { user } = useMst();

  const { data: timetableViewData, loading: timetableDataLoading } = useSubscription<
    timetable_items_for_viewSubscription,
    timetable_items_for_viewSubscriptionVariables
  >(TIMETABLE_ITEMS_FOR_VIEW, {
    variables: {
      where: {
        userId: {
          _eq: user.id,
        },
        published: {
          _eq: true,
        },
      },
    },
    fetchPolicy: 'no-cache',
  });

  // set timetable data
  const timetableCalendarItems: TimetableCalendarItem[] | undefined = timetableViewData?.timetable_item.map(
    (timeTableItem) => ({
      timetableItemId: timeTableItem.id,
      title: timeTableItem.batch_subject_configuration?.subject?.code || timeTableItem.batch_subject_extra_slot?.name,
      subject:
        timeTableItem.batch_subject_configuration?.subject?.name ||
        timeTableItem.batch_subject_extra_slot?.batch_subject_configuration?.subject?.name,
      start: moment(timeTableItem.startTime).toDate(),
      end: moment(timeTableItem.endTime).toDate(),
      batch: timeTableItem?.batch_class?.batch?.name,
      class: timeTableItem?.batch_class?.name,
      location: timeTableItem?.location?.name,
      color:
        timeTableItem?.batch_subject_configuration?.subject?.color ||
        timeTableItem.batch_subject_extra_slot?.batch_subject_configuration?.subject?.color,
      type: 'Lecture',
    }),
  );

  return (
    <>
      <AppTours steps={timetableTourSteps.staffViewTimetable} />

      <ViewTimetable
        timetableCalendarItems={timetableCalendarItems}
        timetableDataLoading={timetableDataLoading}
        userId={user.id}
      />
    </>
  );
};
